export enum ModalType {
	editScoreNav = 'editScoreNav',
	editRateNav = 'editRateNav',
	editCharacterNav = 'editCharacterNav',
	editUrlParamsNav = 'editUrlParamsNav',
	editRedirectNav = 'editRedirectNav',
	editGptTextResponseNav = 'editGptTextResponseNav',
	editGeolocationNav = 'editGeolocationNav',
	editCardId = 'editCardId',
	default = 'default',
}
